// Display label for an account (#1153): the production `developerz-ai`
// account is renamed to `developerz-ai-internal` everywhere it surfaces in
// the dashboard chrome (org-switcher trigger + popover rows, Members page
// eyebrow). The underlying GitHub/routing key (`github_login = "developerz-
// ai"`, the `acc_6dc71a28f22a45ec930c2b6bbaabcf4a` id) stays unchanged —
// `orgFromPath` still keys on `developerz-ai`, the URL stays `/org/
// developerz-ai/…`, the migration's `WHERE github_login = 'developerz-ai'`
// predicate stays intact. Pure display-only swap.
//
// Other accounts keep their `github_login` as the label — `tesote`,
// `dinndev2`, `ivndev001`, `MeepCastana`, etc. — so no org is surprised.

export const DEV_AI_DISPLAY_LABEL = 'developerz-ai-internal';

/**
 * The label to render for an account. `org` is the dashboard's normal
 * account identifier — the URL org segment (`orgFromPath`) or a
 * membership's `github_login` (the `MembershipView` shape exposes both).
 * Returns the renamed label for the production account; falls through to
 * the input otherwise.
 */
export function displayLabelFor(org: string): string {
  return org === 'developerz-ai' ? DEV_AI_DISPLAY_LABEL : org;
}
